module.exports = __webpack_public_path__ + "img/weddingRingsSecretHeart-Collage.4392860.jpg";